export const USER_CONTAINER_TAG_NAME = 'user-container';
